import React from 'react';
import { BsLayoutTextWindowReverse } from '@react-icons/all-files/bs/BsLayoutTextWindowReverse';

import { decorateComponent } from '../../documentComponents';
import { getDisallowedAncestors } from '../../utils';
import { StickyTab } from './StickyTab';
import { StickyTabInspector } from './StickyTab.Inspector';

export default decorateComponent(StickyTab, 'block', {
  id: 'stickyTab',
  label: '스티키 탭',
  defaultProps: {},
  allowedChildren: ['stickyTabItem'],
  disallowedAncestors: getDisallowedAncestors(['sticky-tab']),
  renderIcon: () => <BsLayoutTextWindowReverse />,
  renderInspector: StickyTabInspector,
});
